import React from 'react';
import {ErrorMessage, Field} from 'formik';

const showOtherAmount = async () => {
  await document.getElementById("js-other-amount").classList.remove("hidden");
  await document.getElementById("js-other-amount-label").classList.add("hidden");
  await document.getElementById("donationAmountText").focus();
}

const hideOtherAmount = async () => {
  await document.getElementById("js-other-amount-label").classList.remove("hidden");
  await document.getElementById("js-other-amount").classList.add("hidden");
}

const SelectAmountToDonateSimple = () => (
  <fieldset className="form-step">
    <div className="form-step__header form-step__header--step1">
      <div className="form-step-header__number">1</div>
      <div className="form-step-header__title">Select the amount to donate</div>
    </div>
    <ul className="form-fields form-fields--options horizontal">
      <li className="form-field form-field-option">
        <Field type="radio" id="amount-25" name="donationAmount" value="25" onClick={hideOtherAmount} />
        <label htmlFor="amount-25">$25</label>
      </li>
      <li className="form-field form-field-option">
        <Field type="radio" id="amount-50" name="donationAmount" value="50" onClick={hideOtherAmount} />
        <label htmlFor="amount-50">$50</label>
      </li>
      <li className="form-field form-field-option">
        <Field type="radio" id="amount-100" name="donationAmount" value="100" onClick={hideOtherAmount} />
        <label htmlFor="amount-100">$100</label>
      </li>
    </ul>
    <ul className="form-fields form-fields--options form-fields--options--other horizontal">
      <li id="js-other-amount-label" className="form-field form-field-option">
        <Field type="radio" id="amount-other" name="donationAmount" value="other" onClick={showOtherAmount} />
        <label htmlFor="amount-other">Other amount</label>
      </li>

      <li id="js-other-amount" className="form-field form-field-other-text hidden">
        <Field id="donationAmountText" type="text" pattern="[0-9]*" name="otherAmount" onClick={showOtherAmount} placeholder="Enter your amount" />
        <ErrorMessage name="otherAmount">
          {(msg) => (
            <ul className="validationErrors">
              <li id="otherAmount-error" className="formValidationError">
                {msg}
              </li>
            </ul>
          )}
        </ErrorMessage>
      </li>
    </ul>
  </fieldset>
);
export default SelectAmountToDonateSimple;
